import authApi from '@/api/auth'
import axios from 'axios'
import store from "@/store"

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL,
  timeout: process.env.NODE_ENV === 'development' ? 60000 : 30000
})

service.interceptors.request.use(config => {
  const token = authApi.getToken()

  if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    
    return config
  }
)

service.interceptors.response.use(response => {
  return {
    success: true,
    status: response.status,
    data: response.data
  }
}, (error) => {
  if (store.getters['user/isLogged'] && error.response.status == 401) {
    store.dispatch('auth/logout')
    return Promise.reject(error)
  }

  return Promise.reject({
    success: false,
    status: error.response ? error.response.status : 'unknown',
    data: error.response ? error.response.data : null
  });
})

const request = function (params) {
  if (params.url && !params.url.match(/^\/?v\d/)) {
    params.url = ('/v1/' + params.url).replace(/\/{2,}/g, '/')
  }

  return service(params)
}

export default request
